(function() {
  const isIE9or10 = /MSIE (10|9)/.test(navigator.appVersion);
  if (isIE9or10) {
    Object.setPrototypeOf = undefined;
    const nativeGetPrototypeOf = Object.getPrototypeOf;
    Object.getPrototypeOf = function(object) {
      if (object.__proto__) {
        return object.__proto__;
      } else {
        return nativeGetPrototypeOf.call(Object, object);
      }
    };
  }
})();



// WEBPACK FOOTER //
// ./src/polyfill/fix-ie10-below-extend-bug.js